import { all, takeLatest } from "redux-saga/effects";
import { types as modalsAnchorActions } from "@/bit/reducers/reducers.modals-reducer";
import { types as headerActions } from "@/bit/reducers/reducers.header-reducer";
import { types as mainActions } from "@/bit/reducers/reducers.main-reducer";
import { types as devicesActions } from "@/reducers/devices";
import { initAnchorModalListener, addModal } from "@/bit/sagas/sagas.modals-saga";
import { getSearcherInfo, getRelatedPages } from "@/bit/sagas/sagas.header-saga";
import { checkCPAndSetZones } from "@/bit/sagas/sagas.main-saga";
import { getDevices } from "@/sagas/devices";

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    //searcher
    takeLatest(headerActions.GET_SEARCHER_INFO, getSearcherInfo),
    takeLatest(headerActions.GET_RELATED_PAGES, getRelatedPages),
    //cp
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    //tradeIn
    takeLatest(devicesActions.GET_DEVICES, getDevices),
  ]);
}

export default rootSaga;
